import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-calendar/src/index.js
// module id = 781
// module chunks = 0